import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { PrescriptionApi } from '../../../apis/PrescriptionApi/PrescriptionApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { IValidatePrescriptionsRequest, PrescriptionData } from '../Prescription';

export function useValidatePrescriptions(patientId?: string | number) {
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    return useMutation<PrescriptionData, AppMedError, IValidatePrescriptionsRequest>({
        mutationKey: [QueryKeys.prescription, 'validate'],
        mutationFn: async (request) => {
            return await PrescriptionApi.validatePrescriptions(request);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.prescription] });
            if (patientId != null)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.prescriptionActivity, String(patientId)] });

            notifications.show({
                title: t('prescriptionHistory.notifications.validateSuccess.title'),
                message: t('prescriptionHistory.notifications.validateSuccess.message'),
                color: 'green',
            });
        },
        onError: (error: AppMedError) => {
            notifications.show({
                title: t('prescriptionHistory.notifications.validateError.title'),
                message: error?.message || t('prescriptionHistory.notifications.validateError.message'),
                color: 'red',
            });
        },
    });
}
